class HoverTransition extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="hover-transition">
          Hover Transition
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#mixins-mixin-hover-transition" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">Hover transition with adn without parameters</h4>
              <div className="demo__code">
                <CodeBlock lang="html">
                {`
<p class="hover-transition-demo">
  <button class="button button-1">I transition 2 properties</button>
  <button class="button button-2">I transition all properties!</button>
</p>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.hover-transition-demo {
  .button {
    border: 1px solid $azure;
    height: 40px;
    display: inline-block;
    margin-right: 20px;
    color: $white;
  }

  .button-1 {
    @include hover-transition(background, opacity);
    background: $azure;
    opacity: 1;

    &:hover {
      background: $lipstick;
      opacity: .5;
    }
  }

  .button-2 {
    @include hover-transition();
    background: $azure;
    color: $white;
    opacity: 1;

    &:hover {
      background: $lipstick;
      color: $pure-black;
      opacity: .5;
    }
  }
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <p className="hover-transition-demo">
                    <button className="button button-1">I transition 2 properties</button>
                    <button className="button button-2">I transition all properties!</button>
                  </p>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
